
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import functionsCatalogPreviewTableDescriptor from './FunctionsCatalogPreviewTableDescriptor.json'
import { FilterOperator } from 'primevue/api'

export default defineComponent({
    name: 'function-catalog-preview-table',
    components: { Column, DataTable },
    props: { previewColumns: { type: Array }, previewRows: { type: Array } },
    data() {
        return {
            functionsCatalogPreviewTableDescriptor,
            columns: [] as any[],
            rows: [] as any[],
            filters: { global: [filterDefault] } as Object,
            globalFilterFields: [] as string[]
        }
    },
    watch: {
        previewColumns() {
            this.loadColumns()
        },
        previewRows() {
            this.loadRows()
        }
    },
    created() {
        this.loadColumns()
        this.loadRows()
    },
    methods: {
        loadColumns() {
            this.columns = []
            this.previewColumns?.forEach((el: any) => {
                this.columns.push(el)
                this.globalFilterFields.push(el.field)
                this.filters[el.field] = { operator: FilterOperator.AND, constraints: [filterDefault] }
            })
        },
        loadRows() {
            this.rows = this.previewRows as any[]
        }
    }
})
